import { render } from "./ShowAffectation.vue?vue&type=template&id=2b69a29e"
import script from "./ShowAffectation.vue?vue&type=script&lang=js"
export * from "./ShowAffectation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__